import configurationsRoutes from './configurations'
import remoteRoutes from './remote'
import diagnosticRoutes from './diagnostic'

const Gateway = () => import(/* webpackChunkName: "v-gateway" */ '@/components/page/gateway/Gateway')
const Overview = () => import(/* webpackChunkName: "v-gateway" */ '@/components/page/gateway/overview/Overview')
const Kpi = () => import(/* webpackChunkName: "v-kpi" */ '@/components/page/gateway/Kpi')
const DataUp = () => import(/* webpackChunkName: "v-gateway" */ '@/components/page/gateway/DataUp')
const DataDown = () => import(/* webpackChunkName: "v-gateway" */ '@/components/page/gateway/DataDown')
const Spectrums = () => import(/* webpackChunkName: "v-gateway" */ '@/components/page/gateway/spectrums/Spectrums')
const SpectrumsViewer = () => import(/* webpackChunkName: "v-spectrum" */ '@/components/page/gateway/spectrums/Viewer')

const routes = [
  {
    path: 'gateways/:eui',
    component: Gateway,
    props: true,
    children: [
      {
        path: '',
        name: 'gatewayRoute',
        redirect: 'overview'
      }, {
        path: 'overview',
        name: 'gatewayOverview',
        component: Overview,
        props: true,
        meta: {
          hasFloatingButton: true
        }
      },
      ...configurationsRoutes,
      {
        path: 'kpi',
        name: 'gatewayKpi',
        component: Kpi,
        props: true
      }, {
        path: 'data-up',
        name: 'gatewayDataUp',
        component: DataUp,
        props: true,
        meta: {
          dropdown: 'data'
        }
      }, {
        path: 'data-down',
        name: 'gatewayDataDown',
        component: DataDown,
        props: true,
        meta: {
          dropdown: 'data'
        }
      },
      ...remoteRoutes,
      {
        path: 'spectrums',
        name: 'gatewaySpectrumsList',
        component: Spectrums,
        props: true,
        meta: {
          hasFloatingButton: true
        }
      }, {
        path: 'spectrums/:id',
        name: 'gatewaySpectrumsViewer',
        component: SpectrumsViewer,
        props: true
      },
      ...diagnosticRoutes
    ]
  }
]

export default routes
